export interface Movie {
  id: string;
  title: string;
  category: 'movie' | 'tv' | 'anime' | 'variety';
  subcategory: string;
  year: number;
  rating: number;
  imageUrl: string;
  description: string;
  director: string;
  actors: string[];
  duration: string;
  updateInfo: string;
  isNew: boolean;
  isHot: boolean;
  slug: string;
}

export const categories = [
  { slug: 'movie', name: '电影', icon: 'ri-film-line' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-ancient-gate-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-live-line' },
];

export const subcategories: Record<string, string[]> = {
  movie: ['动作', '喜剧', '爱情', '科幻', '恐怖', '剧情', '悬疑', '战争', '动画', '纪录片'],
  tv: ['国产剧', '港台剧', '日韩剧', '欧美剧', '网剧'],
  anime: ['国产动漫', '日本动漫', '欧美动漫', '剧场版'],
  variety: ['真人秀', '脱口秀', '音乐', '竞技', '访谈'],
};

export const movies: Movie[] = [
  {
    id: '1',
    title: '流浪地球3',
    category: 'movie',
    subcategory: '科幻',
    year: 2026,
    rating: 8.9,
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20featuring%20astronauts%20and%20a%20giant%20planet%20in%20deep%20space%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20cool%20blue%20contrast%2C%20Chinese%20science%20fiction%20film%20aesthetic%2C%20epic%20scale%2C%20clean%20dark%20background%20with%20stars&width=600&height=840&seq=movie-poster-01&orientation=portrait',
    description: '在太阳急速衰老膨胀的未来，人类面临前所未有的生存危机。联合政府决定启动"流浪地球计划"，倾全球之力建造上万座行星发动机，推动地球逃离太阳系，前往4.2光年外的新家园。这是一场持续2500年、跨越100代人的漫长旅程，人类的勇气和坚毅将接受终极考验。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    duration: '173分钟',
    updateInfo: '2026年HD高清版',
    isNew: true,
    isHot: true,
    slug: 'liu-lang-di-qiu-3',
  },
  {
    id: '2',
    title: '满江红',
    category: 'movie',
    subcategory: '剧情',
    year: 2023,
    rating: 8.3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20movie%20poster%20with%20ancient%20palace%20courtyard%2C%20red%20lanterns%20hanging%2C%20mysterious%20atmosphere%2C%20dark%20night%20scene%2C%20traditional%20Chinese%20architecture%2C%20minimalist%20composition%20with%20clean%20dark%20background&width=600&height=840&seq=movie-poster-02&orientation=portrait',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信不翼而飞。小兵张大与亲兵营副统领孙均机缘巧合被裹挟进这个巨大阴谋之中，宰相秦桧命两人寻找凶手和真相。',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音', '岳云鹏'],
    duration: '159分钟',
    updateInfo: '2026年4K修复版',
    isNew: false,
    isHot: true,
    slug: 'man-jiang-hong',
  },
  {
    id: '3',
    title: '孤注一掷',
    category: 'movie',
    subcategory: '剧情',
    year: 2023,
    rating: 8.1,
    imageUrl: 'https://readdy.ai/api/search-image?query=Intense%20crime%20thriller%20movie%20poster%20with%20digital%20screens%20and%20computer%20code%20elements%2C%20dark%20gritty%20urban%20atmosphere%2C%20red%20and%20black%20color%20scheme%2C%20modern%20tech-noir%20aesthetic%2C%20clean%20dark%20background&width=600&height=840&seq=movie-poster-03&orientation=portrait',
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，出国淘金却意外落入境外诈骗工厂的陷阱。为了离开，两人准备向赌徒阿天和其女友小雨下手套现完成业绩。警察赵东冉跨国追查，揭露了一个庞大而复杂的犯罪网络。',
    director: '申奥',
    actors: ['张艺兴', '金晨', '咏梅', '王传君', '王大陆'],
    duration: '130分钟',
    updateInfo: 'HD高清版',
    isNew: false,
    isHot: true,
    slug: 'gu-zhu-yi-zhi',
  },
  {
    id: '4',
    title: '长安三万里',
    category: 'movie',
    subcategory: '动画',
    year: 2023,
    rating: 8.7,
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20animation%20movie%20poster%20featuring%20ancient%20Tang%20Dynasty%20cityscape%20with%20palace%20and%20flying%20birds%2C%20warm%20golden%20sunset%20colors%2C%20traditional%20Chinese%20painting%20style%2C%20poetic%20artistic%20atmosphere%2C%20clean%20elegant%20background&width=600&height=840&seq=movie-poster-04&orientation=portrait',
    description: '安史之乱后数年，吐蕃大军入侵西南，大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军回忆起自己与李白的一生往事。影片展现了盛唐文人墨客的浪漫与豪情，以及那段波澜壮阔的历史岁月。',
    director: '谢君伟',
    actors: ['杨天翔', '凌振赫', '吴俊全', '宣晓鸣'],
    duration: '168分钟',
    updateInfo: '2026年4K收藏版',
    isNew: false,
    isHot: true,
    slug: 'chang-an-san-wan-li',
  },
  {
    id: '5',
    title: '封神第一部',
    category: 'movie',
    subcategory: '动作',
    year: 2023,
    rating: 8.5,
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20movie%20poster%20with%20ancient%20warriors%20and%20mythical%20creatures%2C%20grand%20battle%20scene%2C%20golden%20and%20crimson%20color%20palette%2C%20traditional%20Chinese%20mythology%20aesthetic%2C%20dramatic%20cinematic%20lighting%2C%20clean%20dark%20background&width=600&height=840&seq=movie-poster-05&orientation=portrait',
    description: '商王殷寿暴虐无道，引发天谴。昆仑仙人姜子牙携封神榜下山，寻找天下共主以救苍生。西伯侯之子姬发觉醒，带领各方势力反抗暴政。一场轰轰烈烈的封神之战就此拉开帷幕，三界众生卷入这场浩劫。',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适', '陈牧驰'],
    duration: '148分钟',
    updateInfo: 'HD高清版',
    isNew: false,
    isHot: false,
    slug: 'feng-shen-di-yi-bu',
  },
  {
    id: '6',
    title: '消失的她',
    category: 'movie',
    subcategory: '悬疑',
    year: 2023,
    rating: 8.0,
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20suspense%20thriller%20movie%20poster%20with%20a%20woman%20silhouette%20disappearing%20into%20shadows%2C%20tropical%20island%20night%20scene%2C%20deep%20blue%20and%20black%20tones%2C%20intriguing%20noir%20atmosphere%2C%20clean%20dark%20background&width=600&height=840&seq=movie-poster-06&orientation=portrait',
    description: '何非的妻子李木子在结婚周年旅行中离奇消失。何非报案无果后，一个陌生女人突然出现并声称自己就是他的妻子。当何非陷入迷茫与恐惧时，金牌律师陈麦介入此案，更多谜团也浮现水面。',
    director: '崔睿',
    actors: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    duration: '121分钟',
    updateInfo: 'HD高清版',
    isNew: false,
    isHot: false,
    slug: 'xiao-shi-de-ta',
  },
  {
    id: '7',
    title: '漫长的季节',
    category: 'tv',
    subcategory: '国产剧',
    year: 2023,
    rating: 9.4,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20series%20poster%20with%20nostalgic%201990s%20northeast%20China%20industrial%20town%20setting%2C%20autumn%20leaves%20and%20railway%20tracks%2C%20warm%20amber%20and%20rust%20tones%2C%20melancholic%20atmosphere%2C%20clean%20dark%20background&width=600&height=840&seq=movie-poster-07&orientation=portrait',
    description: '出租车司机王响在二十年后重新追查当年儿子死亡的真相。1990年代的东北小城桦林，一系列神秘事件改变了多个家庭的命运。时间跨越二十年，真相在漫长的季节中逐渐浮出水面。',
    director: '辛爽',
    actors: ['范伟', '秦昊', '陈明昊', '李庚希', '刘琳'],
    duration: '12集',
    updateInfo: '全12集',
    isNew: false,
    isHot: true,
    slug: 'man-chang-de-ji-jie',
  },
  {
    id: '8',
    title: '狂飙',
    category: 'tv',
    subcategory: '国产剧',
    year: 2023,
    rating: 9.1,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%20with%20two%20men%20facing%20off%2C%20police%20versus%20gangster%20theme%2C%20urban%20night%20cityscape%2C%20dark%20intense%20atmosphere%2C%20red%20and%20black%20color%20contrast%2C%20clean%20dark%20background&width=600&height=840&seq=movie-poster-08&orientation=portrait',
    description: '京海市一线刑警安欣在与黑恶势力的斗争中，与以高启强为首的黑社会性质组织展开了长达二十年的生死较量。在全国政法队伍教育整顿的背景下，正义终将战胜邪恶。',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
    duration: '39集',
    updateInfo: '全39集',
    isNew: false,
    isHot: true,
    slug: 'kuang-biao',
  },
  {
    id: '9',
    title: '三体',
    category: 'tv',
    subcategory: '国产剧',
    year: 2023,
    rating: 8.8,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20based%20on%20Three%20Body%20Problem%2C%20cosmic%20scale%20with%20three%20suns%20and%20alien%20civilization%20elements%2C%20deep%20space%20background%2C%20mysterious%20and%20philosophical%20atmosphere%2C%20clean%20dark%20background&width=600&height=840&seq=movie-poster-09&orientation=portrait',
    description: '纳米科学家汪淼被警官史强带入联合作战中心，潜入名为"科学边界"的组织协助调查。在调查过程中，汪淼接触到一个名为"三体"的神秘VR游戏，发现了地球文明正面临来自三体世界的巨大威胁。',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健'],
    duration: '30集',
    updateInfo: '全30集',
    isNew: false,
    isHot: false,
    slug: 'san-ti',
  },
  {
    id: '10',
    title: '莲花楼',
    category: 'tv',
    subcategory: '国产剧',
    year: 2023,
    rating: 8.5,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20poster%20with%20ancient%20Chinese%20warrior%20in%20flowing%20robes%2C%20lotus%20flowers%20and%20misty%20mountains%2C%20elegant%20wuxia%20aesthetic%2C%20soft%20pastel%20colors%20with%20ink%20wash%20painting%20style%2C%20clean%20light%20background&width=600&height=840&seq=movie-poster-10&orientation=portrait',
    description: '昔日武林第一高手李相夷重伤后隐姓埋名成为江湖郎中李莲花。十年后，他遇到了热血少年方多病和旧识笛飞声，三人携手侦破一系列江湖奇案，揭开隐藏在背后的惊天阴谋。',
    director: '郭虎',
    actors: ['成毅', '曾舜晞', '肖顺尧', '陈都灵'],
    duration: '40集',
    updateInfo: '全40集',
    isNew: false,
    isHot: false,
    slug: 'lian-hua-lou',
  },
  {
    id: '11',
    title: '斗破苍穹',
    category: 'anime',
    subcategory: '国产动漫',
    year: 2024,
    rating: 8.6,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20poster%20with%20young%20warrior%20wielding%20flame%20powers%2C%20fantasy%20martial%20arts%20world%2C%20epic%20battle%20scene%20with%20magical%20flames%2C%20vibrant%20animation%20style%2C%20clean%20dark%20background&width=600&height=840&seq=movie-poster-11&orientation=portrait',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后，突然成了废人。种种打击接踵而至，就在他即将绝望之时，一缕灵魂从他手上的戒指里浮现，一扇全新的大门就此开启。',
    director: '赵丙乐',
    actors: ['张沛', '宝木中阳', '郭浩然'],
    duration: '104集',
    updateInfo: '更新至104集',
    isNew: true,
    isHot: true,
    slug: 'dou-po-cang-qiong',
  },
  {
    id: '12',
    title: '完美世界',
    category: 'anime',
    subcategory: '国产动漫',
    year: 2024,
    rating: 8.4,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20poster%20with%20young%20hero%20in%20ancient%20mythological%20world%2C%20celestial%20beings%20and%20divine%20beasts%2C%20epic%20fantasy%20landscape%20with%20floating%20mountains%2C%20vivid%20colorful%20animation%20style%2C%20clean%20dark%20background&width=600&height=840&seq=movie-poster-12&orientation=portrait',
    description: '石昊自幼被夺走至尊骨，流落至石村。在这个蛮荒世界中，他凭借自己的毅力和天赋，一步步踏上修炼之路，立志成为天地间最强的存在。',
    director: '汪成果',
    actors: ['锦鲤', '张杰', '赵爽'],
    duration: '182集',
    updateInfo: '更新至182集',
    isNew: false,
    isHot: true,
    slug: 'wan-mei-shi-jie',
  },
  {
    id: '13',
    title: '一人之下',
    category: 'anime',
    subcategory: '国产动漫',
    year: 2024,
    rating: 9.0,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20poster%20with%20modern%20urban%20supernatural%20martial%20arts%20theme%2C%20young%20characters%20with%20mystical%20powers%2C%20dynamic%20action%20pose%2C%20neon%20city%20night%20background%2C%20stylish%20contemporary%20animation%20aesthetic&width=600&height=840&seq=movie-poster-13&orientation=portrait',
    description: '普通大学生张楚岚在爷爷坟墓被盗后，意外卷入了"异人"的世界。他结识了神秘少女冯宝宝，加入了"哪都通"快递公司，开始了一段充满危险与惊喜的冒险之旅。',
    director: '危天行',
    actors: ['夏侯落枫', '小连杀', '藤新'],
    duration: '60集',
    updateInfo: '第五季更新中',
    isNew: true,
    isHot: false,
    slug: 'yi-ren-zhi-xia',
  },
  {
    id: '14',
    title: '乘风破浪的姐姐',
    category: 'variety',
    subcategory: '真人秀',
    year: 2024,
    rating: 8.2,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20glamorous%20female%20celebrities%20on%20stage%2C%20shiny%20stage%20lights%20and%20sparkles%2C%20empowering%20atmosphere%2C%20fashionable%20and%20elegant%20style%2C%20clean%20dark%20background%20with%20golden%20accents&width=600&height=840&seq=movie-poster-14&orientation=portrait',
    description: '多位30+的知名女艺人重新出发，通过封闭式训练和舞台竞演，最终组成全新女团。展现成熟女性的魅力、勇气和无限可能。',
    director: '吴梦知',
    actors: ['宁静', '那英', '王心凌', '薛凯琪', '钟欣潼'],
    duration: '12期',
    updateInfo: '第五季更新中',
    isNew: true,
    isHot: true,
    slug: 'cheng-feng-po-lang-de-jie-jie',
  },
  {
    id: '15',
    title: '脱口秀大会',
    category: 'variety',
    subcategory: '脱口秀',
    year: 2024,
    rating: 8.0,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20stand-up%20comedy%20show%20poster%20with%20microphone%20on%20stage%2C%20spotlight%20and%20colorful%20stage%20lights%2C%20humorous%20and%20lively%20atmosphere%2C%20modern%20entertainment%20aesthetic%2C%20clean%20dark%20background&width=600&height=840&seq=movie-poster-15&orientation=portrait',
    description: '来自全国各地的脱口秀演员齐聚舞台，用幽默诙谐的语言讲述生活百态，为观众带来欢笑与思考。',
    director: '叶烽',
    actors: ['李诞', '王建国', '呼兰', '庞博', '杨笠'],
    duration: '10期',
    updateInfo: '第六季更新中',
    isNew: false,
    isHot: false,
    slug: 'tuo-kou-xiu-da-hui',
  },
  {
    id: '16',
    title: '飞驰人生2',
    category: 'movie',
    subcategory: '喜剧',
    year: 2024,
    rating: 8.3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20racing%20movie%20poster%20with%20racing%20cars%20on%20track%2C%20desert%20rally%20scene%2C%20action%20and%20humor%20blend%2C%20warm%20sunset%20colors%2C%20cinematic%20adventure%20aesthetic%2C%20clean%20dark%20background&width=600&height=840&seq=movie-poster-16&orientation=portrait',
    description: '昔日冠军车手张驰沦为驾校教练，过着平淡的生活。濒临停产的老头乐车厂厂长主动提出赞助张驰组建车队，再闯最后一届巴音布鲁克拉力赛。面对现实的重重困难和年轻对手的挑战，张驰决定最后再拼一次。',
    director: '韩寒',
    actors: ['沈腾', '范丞丞', '尹正', '张本煜', '孙艺洲'],
    duration: '129分钟',
    updateInfo: '2026年院线版',
    isNew: true,
    isHot: true,
    slug: 'fei-chi-ren-sheng-2',
  },
  {
    id: '17',
    title: '庆余年第二季',
    category: 'tv',
    subcategory: '国产剧',
    year: 2024,
    rating: 8.7,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20young%20scholar%20in%20ancient%20royal%20court%2C%20palace%20intrigue%20theme%2C%20elegant%20traditional%20costumes%2C%20warm%20golden%20and%20red%20tones%2C%20clean%20dark%20background&width=600&height=840&seq=movie-poster-17&orientation=portrait',
    description: '范闲从北齐归来后，面临着更加复杂的朝堂斗争。二皇子谋反、长公主回归、北齐暗流涌动，各方势力交织碰撞。范闲既要守护所爱之人，又要在权力的漩涡中寻找自己的道路。',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    duration: '36集',
    updateInfo: '全36集',
    isNew: false,
    isHot: true,
    slug: 'qing-yu-nian-di-er-ji',
  },
  {
    id: '18',
    title: '功夫熊猫4',
    category: 'anime',
    subcategory: '欧美动漫',
    year: 2024,
    rating: 8.1,
    imageUrl: 'https://readdy.ai/api/search-image?query=Kung%20Fu%20Panda%20animated%20movie%20poster%20with%20panda%20in%20martial%20arts%20pose%2C%20Chinese%20temple%20and%20mountain%20background%2C%20colorful%20and%20dynamic%20animation%20style%2C%20family-friendly%20adventure%20theme%2C%20clean%20warm%20background&width=600&height=840&seq=movie-poster-18&orientation=portrait',
    description: '阿宝即将从神龙大侠晋升为和平谷的精神领袖，他需要找到并训练下一位神龙大侠。与此同时，一位强大的反派变色龙"魅影妖后"现身，她可以召唤阿宝过去所有的敌人。',
    director: '迈克·米切尔',
    actors: ['黄渤', '杨幂', '蒋欣'],
    duration: '94分钟',
    updateInfo: '2026年国语配音版',
    isNew: true,
    isHot: false,
    slug: 'gong-fu-xiong-mao-4',
  },
];

export function getMoviesByCategory(category: string): Movie[] {
  return movies.filter((m) => m.category === category);
}

export function getMovieBySlug(slug: string): Movie | undefined {
  return movies.find((m) => m.slug === slug);
}

export function getHotMovies(limit: number = 8): Movie[] {
  return movies.filter((m) => m.isHot).slice(0, limit);
}

export function getNewMovies(limit: number = 8): Movie[] {
  return movies.filter((m) => m.isNew).slice(0, limit);
}

export function getRelatedMovies(movie: Movie, limit: number = 6): Movie[] {
  return movies
    .filter((m) => m.id !== movie.id && m.category === movie.category)
    .slice(0, limit);
}